import { Component, DestroyRef, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { portalConst } from '@app/config';
import { LearningTrailsElementsService } from '@app/core';
import { ElementData, MainAnnex } from '@app/core/models/courses.model';
import { StatusEnum } from '@app/core/models/status.enum';
import { BehaviorSubject, filter, switchMap, takeWhile, timer } from 'rxjs';

@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
  styles: [],
  standalone: false,
})
export class VideoCardComponent {
  @Input() public fullWidth = false;
  @Input() public fullSize = false;
  public videoWithLink = false;
  public elementData$ = new BehaviorSubject<ElementData>(undefined);
  public rendering$ = new BehaviorSubject<boolean>(true);

  constructor(private destroyRef: DestroyRef, private learningTrailsElementsService: LearningTrailsElementsService) {}

  @Input({ required: true })
  public set element(element: ElementData) {
    this.elementData$.next(element);
    if (element?.anexo_principal.video && !element?.anexo_principal.vimeo_hash) {
      const data = {
        id: element.anexo_principal?.id,
        video: element.anexo_principal?.video,
        conta: portalConst.vimeo_account,
      };
      this.getInfoVimeo(data);
    }
  }

  public getVideoUrl(annex: MainAnnex): string {
    if (!!annex.link) {
      this.videoWithLink = true;
      return annex.link.concat((annex.link.includes('?') ? '&' : '?') + 'title=0&portrait=0&byline=0');
    }

    this.videoWithLink = false;
    return this.urlVideo(annex);
  }

  private urlVideo(anexo: MainAnnex): string {
    return `${portalConst.vimeo_url}${anexo.video.replace(/[/videos/]/gi, '')}?h=${
      anexo.vimeo_hash
    }&title=false&byline=false&portrait=false`;
  }

  private getInfoVimeo(data: any): void {
    this.rendering$.next(false);
    timer(0, 60000)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        takeWhile(() => !this.rendering$.value),
        switchMap(() => this.learningTrailsElementsService.checkVideo(data)),
        filter(({ ret }) => ret === StatusEnum.Active),
      )
      .subscribe((video: any) => {
        const annex = this.elementData$.value?.anexo_principal;
        annex.thumbnail = video.thumbnail;
        annex.vimeo_hash = video.vimeo_hash;
        this.elementData$.next({ ...this.elementData$.value, anexo_principal: annex });
        this.rendering$.next(true);
      });
  }
}
